import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import BottomButtons from "components/buttons/bottomButtons";
import HeadingComponent from "components/headingComponent";
import ErrorMessages from "helper/errorMessages";
import ButtonLabels from "helper/constant/buttonLabels";
import CommonHeadings from "helper/constant/headings";
import { dbFirestore } from "helper/config/firebase";
import TableName from "helper/tableName/tableName";
import RoutingPaths from "helper/routingPath";
import ToastMessages from "helper/toastMessages";
import {
  addDoc,
  collection,
  doc,
  Timestamp,
  updateDoc,
} from "firebase/firestore";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dateformat from "helper/constant/timeFormat";
import "./index.css"

function AddBasicExpenses() {
  const [isSubmitted, setIsSubmitted] = useState(false); // when we submit the form, it will check the error
  const [expenseDate, setExpenseDate] = useState(null);
  const [expenseHeading, setExpenseHeading] = useState(
    CommonHeadings.basicExpenseAddHeading
  );
  const [buttonLabel, setButtonLabel] = useState(ButtonLabels.saveLabel);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [expensesID, setExpensesID] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  const [expenses, setExpenses] = useState({
    // set input values
    expense_date: null,
    expense_date_num: null,
    description: "",
    amount: "",
    amount_num: null,
  });

  const [errors, setErrors] = useState({
    expense_date: "",
    description: "",
    amount: "",
  });

  // MARK: use effect function
  useEffect(() => {
    if (location.state) {
      setEditExpensessUI();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // MARK: Validation error
  const validateForm = (data) => {
    const errors = {};

    if (!data.expense_date) {
      errors.expense_date = ErrorMessages.date;
    }
    if (!data.description) {
      errors.description = ErrorMessages.description;
    }
    if (!data.amount) {
      errors.amount = ErrorMessages.amount;
    } else if (!/^\d*$/.test(data.amount)) {
      errors.amount = ErrorMessages.amountNumber;
    }

    return errors;
  };

  //   when we enter any value that's set in the setDemoStudents() and chenge the input afer submitting like blank all the inputs
  const inputChange = (e) => {
    var { name, value } = e.target;

    if (name === "expense_date") {
      value = moment(value).format(Dateformat.YYYYMMDD);
    }

    setExpenses({
      ...expenses,
      [name]: value,
    });
  };

  // MARK: payload function
  function payload() {
    const createdAt = Timestamp.fromDate(new Date()).toMillis();

    const object = {
      ...expenses,
      created_at: createdAt,
      updated_at: null,
    };

    object.amount_num = Number(expenses.amount);
    const otherExpenseDate = Timestamp.fromDate(
      new Date(object.expense_date)
    ).toMillis();
    object.expense_date_num = otherExpenseDate;
    object.description = expenses.description.toLowerCase();

    return object;
  }

  // MARK: reset values function
  function ResetValues() {
    setExpenses({
      expense_date: null,
      expense_date_num: null,
      description: "",
      amount: "",
      amount_num: null,
    });
  }

  // MARK: write API
  async function writeExpensesApi(edit) {
    const writePayload = payload();

    try {
      await addDoc(collection(dbFirestore, TableName.basicExpenses), {
        ...writePayload,
      });

      if (edit) {
        toast.success(ToastMessages.expenseAdd);
        setTimeout(() => {
          setLoading2(false);
          // when user press on save + next
          navigate(RoutingPaths.addBasicExpenses);
          ResetValues();
        }, 600);
      } else {
        toast.success(ToastMessages.expenseAdd);
        setTimeout(() => {
          setLoading1(false);
          navigate(RoutingPaths.basicExpensesList);
        }, 600);
      }
    } catch (error) {
      setLoading1(false); // hide
      setLoading2(false);
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // MARK: edit data function
  function setEditExpensessUI() {
    const expenseDate = moment(
      location.state.expense_date,
      Dateformat.YYYYMMDD
    ).toDate();
    setExpenseDate(expenseDate);

    setExpenses((prevState) => ({
      ...prevState,
      expense_date: location.state.expense_date,
      description: location.state.description,
      amount: location.state.amount,
    }));
    setExpenseHeading(CommonHeadings.basicExpenseEditHeading);
    setButtonLabel(ButtonLabels.updateLabel);
    setExpensesID(location.state.id);
  }

  // MARK: update API
  async function updateExpensesApi() {
    const updatedPayload = payload();
    updatedPayload.created_at = location.state.created_at;
    updatedPayload.updated_at = Timestamp.fromDate(new Date()).toMillis();

    try {
      await updateDoc(doc(dbFirestore, TableName.basicExpenses, expensesID), {
        ...updatedPayload,
      });

      toast.success(ToastMessages.expenseUpdated);
      setTimeout(() => {
        setLoading1(false);
        navigate(RoutingPaths.basicExpensesList);
      }, 600);
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
    }
  }

  // this function is working when we submit the form by clicking on save button
  const tapOnSave = () => {
    const newErrors = validateForm(expenses);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading1(true);
      if (location.state) {
        updateExpensesApi();
      } else {
        writeExpensesApi();
      }
    }
  };

  // this function is working when we submit the form by clicking on save andnext button
  const tapOnSaveNext = () => {
    const newErrors = validateForm(expenses);
    setErrors(newErrors);
    setIsSubmitted(true);
    if (Object.keys(newErrors).length === 0) {
      setLoading2(true);
      writeExpensesApi(true);
    }
  };

  return (
    <div className="modules__main__div">
      <div className="col-12">
        <div className="card modules__card">
          <HeadingComponent classname="mb-4" headingName={expenseHeading} />
          {/* p-fluid is the primereact class */}
          <div className="p-fluid">
            <div className="row modules__row">
              <div className="col-12 col-md-6">
                <label htmlFor="expense_date" className="input__valid">
                  Expense Date
                </label>
                <Calendar
                  name="expense_date"
                  value={expenseDate}
                  onChange={inputChange}
                  showIcon
                  showButtonBar
                  placeholder="dd/mm/yyyy"
                  dateFormat="dd/mm/yy"
                />
                {isSubmitted && (
                  <small id="expense_date" className="p-error">
                    {errors.expense_date}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="amount" className="input__valid">
                  Amount
                </label>
                <InputText
                  name="amount"
                  value={expenses.amount}
                  onChange={inputChange}
                  id="amount"
                  type="text"
                  placeholder="Enter amount"
                  maxLength={10}
                />
                {isSubmitted && (
                  <small id="amount" className="p-error">
                    {errors.amount}{" "}
                  </small>
                )}
              </div>

              <div className="col-12 col-md-6">
                <label htmlFor="description" className="input__valid">
                  Description
                </label>
                <InputTextarea
                  name="description"
                  value={expenses.description}
                  onChange={inputChange}
                  id="description"
                  placeholder="Enter description"
                  rows={3}
                  cols={30}
                />
                {isSubmitted && (
                  <small id="description" className="p-error">
                    {errors.description}{" "}
                  </small>
                )}
              </div>
            </div>
          </div>
          <BottomButtons
            label={buttonLabel}
            save={tapOnSave}
            loading1={loading1}
            saveNext={tapOnSaveNext}
            loading2={loading2}
          />
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}

export default AddBasicExpenses;
